import React from "react";
import {Box, Pagination, Stack} from "@mui/material";

const CustomPagination = ({currentPage, totalPages, onPageChange}) => {
    const handleChange = (_, page) => {
        onPageChange(page);
    };

    return (
        <Box sx={{marginBottom: '50px'}}>
            <Stack spacing={2} alignItems="center" sx={{marginTop: 2}}>
                <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={handleChange}
                    color="primary"
                    showFirstButton
                    showLastButton
                />
            </Stack>
        </Box>
    );
};

export default CustomPagination;
